var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsMyDelivery = function SvgNnIconFlagsMyDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-MY-delivery_svg__Lager_57",
    "data-name": "Lager 57",
    viewBox: "0 0 50.47 33.82"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-MY-delivery_svg__cls-3{fill:#e60026}.nn-icon-flags-MY-delivery_svg__cls-6{fill:#ffd900}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.13.13h50.22V33.7H.13z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-MY-delivery_svg__v"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MY-delivery_svg__t",
    d: "M.25.25h49.97v2.38H.25z",
    className: "nn-icon-flags-MY-delivery_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MY-delivery_svg__t-2",
    d: "M.25 5.01h49.97v2.38H.25z",
    className: "nn-icon-flags-MY-delivery_svg__cls-3",
    "data-name": "t"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MY-delivery_svg__t-3",
    d: "M.25 9.77h49.97v2.38H.25z",
    className: "nn-icon-flags-MY-delivery_svg__cls-3",
    "data-name": "t"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MY-delivery_svg__t-4",
    d: "M.25 14.53h49.97v2.38H.25z",
    "data-name": "t",
    style: {
      fill: "#f21000"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MY-delivery_svg__t-5",
    d: "M.25 14.53h49.97v2.38H.25z",
    className: "nn-icon-flags-MY-delivery_svg__cls-3",
    "data-name": "t"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MY-delivery_svg__t-6",
    d: "M.25 19.29h49.97v2.38H.25z",
    className: "nn-icon-flags-MY-delivery_svg__cls-3",
    "data-name": "t"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MY-delivery_svg__t-7",
    d: "M.25 24.05h49.97v2.38H.25z",
    className: "nn-icon-flags-MY-delivery_svg__cls-3",
    "data-name": "t"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-MY-delivery_svg__t-8",
    d: "M.25 28.81h49.97v2.38H.25z",
    className: "nn-icon-flags-MY-delivery_svg__cls-3",
    "data-name": "t"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h24.98v19.04H.25z",
    style: {
      fill: "#0016af",
      stroke: "#87888a",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92 9.77a6.34 6.34 0 0 1 6.31-6.35 6.3 6.3 0 0 1 2.57.55 7.14 7.14 0 1 0 0 11.6 6.3 6.3 0 0 1-2.57.55 6.34 6.34 0 0 1-6.31-6.35",
    className: "nn-icon-flags-MY-delivery_svg__cls-6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m20.2 9.77 3.42-1.32-3.66.29 2.51-2.68-3.17 1.85 1.1-3.5-2.05 3.04-.53-3.63-.53 3.63-2.05-3.04 1.09 3.5-3.16-1.85 2.5 2.68-3.65-.29 3.42 1.32-3.42 1.32 3.65-.29-2.5 2.68 3.16-1.85-1.09 3.5 2.05-3.04.53 3.63.53-3.63 2.05 3.04-1.1-3.5 3.17 1.85-2.51-2.68 3.66.29z",
    className: "nn-icon-flags-MY-delivery_svg__cls-6"
  })));
};
export default SvgNnIconFlagsMyDelivery;